import Upload2  from  './Upload'

export default Upload2